import React from 'react';
import {
  shape,
  string,
  arrayOf,
  func,
} from 'prop-types';
import AmexGDAChefCard from './AmexGDAChefCard';
import './AmexGDAChef.scss';

const AmexGDAChef = ({ baseRequestUrl, chefData: { chefList, heading }, printContent }) => {
  const slicedChefList = chefList.slice(0, 5);
  const colsNumber = slicedChefList.length;
  const maxWidth = (210 * colsNumber) + (20 * (colsNumber - 1));

  return (
    <div className="GDA__Chef">
      <h2>{heading}</h2>
      <div className="GDA__Chef__wrapper">
        <ul
          className="GDA__Chef__list"
          style={{
            gridTemplateColumns: `repeat(${colsNumber}, minmax(210px, 210px))`,
            maxWidth,
          }}
        >
          {slicedChefList.map((chef) => (
            <AmexGDAChefCard
              baseRequestUrl={baseRequestUrl}
              key={`${chef.name}${chef.venueName}`}
              printContent={printContent}
              {...chef}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

AmexGDAChef.propTypes = {
  baseRequestUrl: string.isRequired,
  chefData: shape({
    heading: string,
    chefList: arrayOf(shape({})),
  }).isRequired,
  printContent: func.isRequired,
};

export default AmexGDAChef;
